import { Component, Input, Output, OnInit, forwardRef, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-form-datepicker',
  templateUrl: './form-datepicker.component.html',
  styleUrls: ['./form-datepicker.component.sass'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormDatepickerComponent),
      multi: true
    }
  ]
})
export class FormDatepickerComponent implements OnInit, ControlValueAccessor {
  @Input()  resetable = true;
  @Input()  required = false;
  @Input()  disabled = false;
  @Input()  name = 'date';
  @Input()  min = null;
  @Input()  max = null;
  @Input()  placeholder = '';
  @Output() dateChange: EventEmitter<any>;
  @ViewChild('dateElement') dateElement: ElementRef;

  public date: Date = null;

  propagateChange = (_: any) => {};

  constructor() {
    this.dateChange = new EventEmitter();
  }

  ngOnInit() {
  }

  writeValue(value: any) {
    this.date = value;
  }

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched() {}

  onDateChange(date) {
    this.propagateChange(date);
    this.dateChange.emit(date);
  }

  onClearClick() {
    this.dateElement.nativeElement.focus();
    this.date = null;
    this.onDateChange(this.date);
    this.dateElement.nativeElement.blur();
  }
}
